/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'GRIEVANCE_SYSTEM_AND_PROCESS',
              'NON_REPRISAL_FOR_WORKERS_FILING_A_GRIEVANCE_COMPLAINT',
              'EQUAL_ACCESS_TO_GRIEVANCE_SYSTEMS_FOR_FEMALE_AND_MALE_WORKERS_A',
              'WORKER_FEEDBACK',
              'EQUAL_IMPORTANCE_GIVEN_TO_ALL_CONCERNS_AND_GRIEVANCES_',
              'COMMITMENT_TO_CONFIDENTIALITY_THROUGHOUT_THE_ENTIRE_GRIEVANCE_P',
              'PROVIDING_TIME_OFF_INCLUDING_MONETARY_COMPENSATION_DURING_A_GRI',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_9: valueSchema,
  },
}
